export default Object.freeze({
  TILES_NAV_ITEM_CLICKED: 'Tiles dropdown navigation item clicked',
  TILES_BANNER_CLICKED: 'Tiles dropdown banner clicked',
  TILES_BUTTON_CLICKED: 'Tiles dropdown bottom button clicked',
});
